import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTreeElement } from './OneUxTreeElement.js';
export const register = getRegisterFunction(OneUxTreeElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tree': OneUxTreeElement;
    "tree-c235eb3b8886bc157fe83e2bb94e3617": OneUxTreeElement;
  }
}